/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  /* footer extend */
  document.querySelectorAll('.footer__block--menu').forEach(function (menuBlock) {
    const header = menuBlock.querySelector('.footer__block__title');
    const content = menuBlock.querySelector('.footer__quicklinks');
  
    header.addEventListener('click', function () {
      content.style.display = (content.style.display === 'block') ? 'none' : 'block';
      header.classList.toggle('active');
    });
  });
  

})();
